import { en, pl } from 'vuetify/locale'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'
import '@mdi/font/css/materialdesignicons.css' // used by vuetify component so has to be imported
import Consts from '../Consts';

const taxi_theme = {
  dark: false,
  colors: {
    // background: '#FFFFFF',
    // surface: '#FFFFFF',
    primary: Consts.color.primary,
    // 'primary-darken-1': '#3700B3',
    // secondary: '#03DAC6',
    // 'secondary-darken-1': '#018786',
    // error: '#B00020',
    // info: '#2196F3',
    // success: '#4CAF50',
    // warning: '#FB8C00',
  }
};

const taxi_theme_dark = {
  dark: true,
  colors: {
    //background: Consts.color.dark_bg,
    //surface: '#FFFFFF',
    primary: Consts.color.primary,
    // 'primary-darken-1': '#3700B3',
    // 'primary-darken-1': '#3700B3',
    // secondary: '#03DAC6',
    // 'secondary-darken-1': '#018786',
    // error: '#B00020',
    // info: '#2196F3',
    // success: '#4CAF50',
    // warning: '#FB8C00',
  }
};

const vuetify_setup = {
  theme: {
    defaultTheme: 'taxi_theme',
    themes: {
      taxi_theme,
      taxi_theme_dark,
    },
  },
  icons: {
    iconfont: 'mdiSvg',
    // defaultSet: 'mdi',
    // aliases,
    // sets: {
    //   mdi,
    // },
  },
}

function vuetify_setup_locale(lang)
{
  let v = {...vuetify_setup}
  v.locale = {
    locale: lang,
    fallback: 'en',
    messages: { en, pl },
  }
  return v
}
export { vuetify_setup, vuetify_setup_locale };
